import React, { useState } from "react";
import { Box, Collapse, useMediaQuery } from "@material-ui/core";
import LinkEcco from "../Link";
import { useStyles } from "../../hooks";
import styles from "./styles";
import { PUBLICURL, ASSETS_S3 } from "../../main_config";
import {
  EMPRESAS_HOME,
  EMPRESAS_ENERGIA,
  EMPRESAS_CONSULTORIO,
  EMPRESAS_AUSENTISMO,
  EMPRESAS_CAPACITACION,
  EMPRESAS_SALVAMENTO,
  EMPRESAS_EVENTOS,
  EMPRESAS_TRASLADOS,
  EMPRESAS_LABORAL,
  EMPRESAS_CUIDADOS,
  EMPRESAS_AREA_PROTEGIDA,
  FAMILIAS_HOME,
  FAMILIAS_CUIDADOS,
  FAMILIAS_TRASLADOS,
  INFO_UTIL,
  LINEA_DENUNCIAS,
  DATOS_IMPOSITIVOS,
} from "../../routes/paths";

const asset = name => `${PUBLICURL}/assets/images/footer/${name}`;

const SOCIAL = [
  { key: "ig", href: "https://www.instagram.com/eccoemergencias", icon: "icon-instagram.svg", label: "Instagram" },
  { key: "fb", href: "https://www.facebook.com/eccoemergencias", icon: "icon-facebook.svg", label: "Facebook" },
  { key: "in", href: "https://www.linkedin.com/company/eccoemergencias", icon: "icon-linkedin.svg", label: "LinkedIn" },
  { key: "yt", href: "https://www.youtube.com/@eccoemergencias", icon: "icon-youtube.svg", label: "YouTube" },
];

const FAMILIA = [
  { label: "ECCO para familias", to: FAMILIAS_HOME },
  { label: "Cuidados domiciliarios", to: FAMILIAS_CUIDADOS },
  { label: "Traslados", to: FAMILIAS_TRASLADOS },
];

const EMPRESAS = [
  { label: "ECCO para empresas y comercios", to: EMPRESAS_HOME, desktopOnly: true },
  { label: "Control de ausentismo", to: EMPRESAS_AUSENTISMO },
  { label: "Área protegida", to: EMPRESAS_AREA_PROTEGIDA },
  { label: "Emergencias y urgencias médicas", to: EMPRESAS_SALVAMENTO },
  { label: "Cuidados domiciliarios", to: EMPRESAS_CUIDADOS },
  { label: "Consultorios in company", to: EMPRESAS_CONSULTORIO },
  { label: "Medicina Laboral", to: EMPRESAS_LABORAL },
  { label: "Cobertura de Eventos", to: EMPRESAS_EVENTOS },
  { label: "Cursos de capacitación", to: EMPRESAS_CAPACITACION },
  { label: "Traslados aéreos", to: EMPRESAS_TRASLADOS },
  { label: "Traslados", to: EMPRESAS_TRASLADOS },
  { label: "ECCO petroleo, gas y minería", to: EMPRESAS_ENERGIA },
];

const INSTITUCIONAL = [
  { label: "Sobre ECCO", to: "/nuestra-empresa" },
  { label: "Teléfonos útiles", to: `${INFO_UTIL}#telefonos-utiles` },
  { label: "Medios de pago", to: `${INFO_UTIL}#medios-de-pago` },
  { label: "Sucursales y Bases operativa (corpo)", to: "/sucursales", desktopOnly: true },
  { label: "Sucursales y Bases operativas", to: "/sucursales", mobileOnly: true },
  { label: "Línea de denuncias", to: LINEA_DENUNCIAS },
  { label: "Datos impositivos", to: DATOS_IMPOSITIVOS },
  { label: "Trabajá con nosotros", href: "mailto:info@ecco.com.ar" },
];

const LEGAL_PDF = {
  contrato: `${ASSETS_S3}/pdf/Contrato_de_Adhesión_Ley_N_24240_de_Defensa_del_Consumidor.pdf`,
  gobierno: `${ASSETS_S3}/pdf/y385etjo.pdf`,
  etica: `${ASSETS_S3}/pdf/ut3424om.pdf`,
};

const FooterLink = ({ item, className, isDesktop }) => {
  if (item.desktopOnly && !isDesktop) return null;
  if (item.mobileOnly && isDesktop) return null;
  if (item.to) {
    return (
      <LinkEcco to={item.to} className={className} underline="none">
        {item.label}
      </LinkEcco>
    );
  }
  if (item.href) {
    return (
      <LinkEcco external url={item.href} href={item.href} className={className} underline="none">
        {item.label}
      </LinkEcco>
    );
  }
  return <Box component="span" className={className}>{item.label}</Box>;
};

const Footer = () => {
  const classes = useStyles(styles);
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const [open, setOpen] = useState(true);

  const columns = (
    <Box className={classes.columns}>
      <Box className={classes.col}>
        <Box className={classes.colTitle} component="p">FAMILIA</Box>
        <Box className={classes.colLinks}>
          {FAMILIA.map(item => (
            <FooterLink key={item.label} item={item} className={classes.colLink} isDesktop={isDesktop} />
          ))}
        </Box>
      </Box>
      <Box className={classes.col}>
        <Box className={classes.colTitle} component="p">COMERCIO Y EMPRESAS</Box>
        <Box className={classes.colLinks}>
          {EMPRESAS.map(item => (
            <FooterLink key={item.label} item={item} className={classes.colLink} isDesktop={isDesktop} />
          ))}
        </Box>
      </Box>
      <Box className={classes.col}>
        <Box className={classes.colTitle} component="p">INSTITUCIONAL</Box>
        <Box className={classes.colLinks}>
          {INSTITUCIONAL.map(item => (
            <FooterLink key={`${item.label}-${item.desktopOnly ? "d" : item.mobileOnly ? "m" : "a"}`} item={item} className={classes.colLink} isDesktop={isDesktop} />
          ))}
        </Box>
      </Box>
      <Box className={classes.col}>
        <Box className={`${classes.colTitle} ${classes.contactTitle}`} component="p">CONTACTO</Box>
        <Box className={classes.contactRows}>
          <Box className={classes.contactRow}>
            <img className={classes.contactIcon} src={asset("icon-phone.svg")} alt="" width={18} height={18} />
            <Box>
              <p className={classes.contactLabel}>Emergencias</p>
              <a className={classes.contactValue} href="tel:08108883226">0810-888-3226</a>
            </Box>
          </Box>
          <Box className={classes.contactRow}>
            <img className={classes.contactIcon} src={asset("icon-whatsapp.svg")} alt="" width={18} height={18} />
            <Box>
              <p className={classes.contactLabel}>Afiliación y Atención al socio (WhatsApp)</p>
              <a
                className={classes.contactValue}
                href="https://api.whatsapp.com/send?phone=541144499787"
                target="_blank"
                rel="noopener noreferrer"
              >
                11-4449-9787
              </a>
            </Box>
          </Box>
          <Box className={classes.contactRow}>
            <img className={classes.contactIcon} src={asset("icon-phone.svg")} alt="" width={18} height={18} />
            <Box>
              <p className={classes.contactLabel}>Atención al socio</p>
              <a className={classes.contactValue} href="tel:08004443226">0800-444-ECCO</a>
            </Box>
          </Box>
          <Box className={classes.contactRow}>
            <img className={classes.contactIcon} src={asset("icon-mail.svg")} alt="" width={18} height={18} />
            <Box>
              <p className={classes.contactLabel}>Email</p>
              <a className={classes.contactValue} href="mailto:info@ecco.com.ar">info@ecco.com.ar</a>
            </Box>
          </Box>
          <Box className={classes.contactRow}>
            <img className={classes.contactIcon} src={asset("icon-headset.svg")} alt="" width={18} height={18} />
            <Box>
              <p className={classes.contactLabel}>Atención en sucursal</p>
              <p className={classes.contactValue}>Lun a Vie 8–20 h · Sáb, Dom y feriados 9–15 h.</p>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box component="footer" className={classes.root}>
      <Box className={classes.main}>
        <Box className={classes.mainInner}>
          <Box className={classes.brandCol}>
            <LinkEcco to="/">
              <img
                className={classes.logo}
                src={`${PUBLICURL}/assets/images/ecco_color.png`}
                alt="ECCO"
                width={120}
              />
            </LinkEcco>
            <p className={classes.brandText}>
              Asistencia médica prehospitalaria. Emergencia y prevención, cuando más lo necesitás.
            </p>
            <p className={classes.brandHighlight}>Parte de Swiss Medical Group.</p>
            <Box className={classes.social}>
              {SOCIAL.map(item => (
                <LinkEcco
                  key={item.key}
                  external
                  url={item.href}
                  href={item.href}
                  aria-label={item.label}
                >
                  <img className={classes.socialIcon} src={asset(item.icon)} alt="" width={24} height={24} />
                </LinkEcco>
              ))}
            </Box>
          </Box>

          {!isDesktop && (
            <button
              type="button"
              className={classes.accordionToggle}
              aria-expanded={open}
              onClick={() => setOpen(v => !v)}
            >
              Más información sobre Ecco
              <img
                className={`${classes.chevron}${open ? "" : ` ${classes.chevronClosed}`}`}
                src={asset("icon-chevron.svg")}
                alt=""
                width={16.5}
                height={9}
              />
            </button>
          )}

          {isDesktop ? columns : <Collapse in={open}>{columns}</Collapse>}
        </Box>
      </Box>

      <Box className={classes.legal}>
        <Box className={classes.badges}>
          <img className={classes.dataFiscal} src={asset("data-fiscal.png")} alt="Data Fiscal" width={76} height={36} />
          <LinkEcco to="/solicitud-arrepentimiento" className={classes.legalBtn} underline="none">
            Botón de arrepentimiento
          </LinkEcco>
          <LinkEcco to="/solicitud-baja" className={classes.legalBtn} underline="none">
            Solicitud de baja
          </LinkEcco>
          <LinkEcco
            external
            url="https://www.argentina.gob.ar/economia/comercio/defensadelconsumidor"
            href="https://www.argentina.gob.ar/economia/comercio/defensadelconsumidor"
            className={classes.legalTextLink}
            underline="none"
          >
            Defensa de las y los Consumidores
          </LinkEcco>
        </Box>
        <Box className={classes.legalLinks}>
          <LinkEcco
            to={LINEA_DENUNCIAS}
            className={classes.legalTextLink}
            underline="none"
          >
            Línea de denuncias
          </LinkEcco>
          <LinkEcco
            external
            url={LEGAL_PDF.contrato}
            href={LEGAL_PDF.contrato}
            className={classes.legalTextLink}
            underline="none"
          >
            Contrato de adhesión
          </LinkEcco>
          <LinkEcco
            external
            url={LEGAL_PDF.gobierno}
            href={LEGAL_PDF.gobierno}
            className={classes.legalTextLink}
            underline="none"
          >
            Código de Gobierno Corporativo
          </LinkEcco>
          <LinkEcco
            external
            url={LEGAL_PDF.etica}
            href={LEGAL_PDF.etica}
            className={classes.legalTextLink}
            underline="none"
          >
            Código de Ética
          </LinkEcco>
        </Box>
      </Box>

      <Box className={classes.notice}>
        <p className={classes.noticeText}>
          Superintendencia de Servicios de Salud — Órgano de control de obras sociales y entidades de medicina prepaga — 0800-222-SALUD (72583) — argentina.gob.ar/sssalud — R.N.E.M.P. N° [a completar]
        </p>
      </Box>

      <Box className={classes.copy}>
        <p className={classes.copyText}>
          © 2026 ECCO Emergencia y Prevención · Swiss Medical Group. Todos los derechos reservados.
        </p>
        <Box className={classes.copyLinks}>
          <span className={classes.copyLink}>Mapa del sitio</span>
          <span>·</span>
          <span className={classes.copyLink}>Accesibilidad</span>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
